<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="$t('elanlar')"
    />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-8">
          <div v-if="announcement===null">
            <div class="alert alert-info">
              {{ $t('login.yklnir') }}
            </div>
          </div>
          <div
            v-else
            class="card"
          >
            <img
              v-if="announcement.photo"
              :src="`${mediaBase}${announcement.photo}`"
              :alt="announcement.title"
            >
            <div class="card-body">
              <h4 class="card-title">
                {{ announcement.title }}
              </h4>

              <div
                class="lead announcement-content"
                v-html="announcement.description"
              />
            </div>

            <div
              v-if="answerList.length > 0"
              class="list-group list-group-flush"
            >
              <div
                v-for="a in answerList"
                class="list-group-item"
              >
                <div
                  v-if="announcement.multiSelect>0"
                  class="d-flex pl-4 justify-content-between"
                >
                  <div class="pl-4">
                    <input
                      v-if="!answers"
                      :id="`pollAnswer${a.id}`"
                      v-model="selectedAnswers"
                      class="form-check-input"
                      type="checkbox"
                      :value="a.id"
                    >
                    <label :for="`pollAnswer${a.id}`">{{ a.label }}</label>
                  </div>
                  <div v-if="answers">
                    {{ $t('announcement.ss', {selected: a.selected}) }}
                  </div>
                </div>
                <div
                  v-else
                  class="d-flex justify-content-between"
                >
                  <div class="pl-2">
                    <input
                      v-if="!answers"
                      :id="`pollAnswer${a.id}`"
                      v-model="selectedAnswerId"
                      class="form-check-input"
                      type="radio"
                      name="announcementPoll"
                      :value="a.id"
                    >
                    <label :for="`pollAnswer${a.id}`">{{ a.label }}</label>
                  </div>
                  <div v-if="answers">
                    {{ $t('announcement.ss', {selected: a.selected}) }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="answerList.length> 0 && !answers"
              class="card-body"
            >
              <button
                class="btn btn-primary"
                @click.prevent="voteAnnouncement"
              >
                {{ $t('announcement.ssVer') }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header">
              <h5>{{ $t('announcement.elanlarVQaydalar') }}</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  v-for="a in announcements"
                  :key="a.id"
                  class="col-sm-4 col-6 mb-3 text-center"
                  style="cursor: pointer"
                  @click="$router.push('/dashboard/announcement/'+a.id)"
                >
                  <img
                    :src="getPhoto(a.photo,'thumbnailCropped')"
                    class="w-100 img-thumbnail rounded-circle"
                    :alt="a.title"
                    :class="{'border-danger border-2': a.isRead<1}"
                  >
                  <div class="dotted-animation">
                    <span class="animate-circle" />
                    <span class="main-circle" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  getAnnouncement,
  getAnnouncements,
  userAccounts, voteAnnouncement,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getPhoto} from "@/repositories/Utils";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      announcements: [],
      announcement: null,
      answers: null,
      answerList: [],
      selectedAnswers: [],
      selectedAnswerId: 0
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),


  },
  watch: {
    token(newValue) {
      userAccounts(newValue).then(data => {
        this.profiles = data;
      });
    },
    "$route"() {
      this.getAnnouncement();
    }
  },
  mounted() {

    this.getAnnouncement();

    getAnnouncements(this.token).then(data => {
      this.announcements = data;
    })

  },
  methods: {
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    getAnnouncement() {
      getAnnouncement(this.token, this.$route.params['id']).then(data => {
        if (data.code === 200) {

          this.announcement = data.announcement;
          this.answerList = data.answerList;
          this.answers = data.answers;

        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },

    voteAnnouncement() {
      if ((this.announcement.multiSelect > 0 && this.selectedAnswers.length > 0)
          || (this.announcement.multiSelect < 1 && this.selectedAnswerId > 0)) {
        voteAnnouncement(this.token, this.announcement.id,
            this.announcement.multiSelect > 0 ? this.selectedAnswers.join(",") : this.selectedAnswerId)
            .then(data => {
          if (data.code === 200) {
            this.$swal({
              title: this.$t("tskkrlr"),
              text: this.$t("ssnzQydAlnd"),
              icon: 'success'
            })
            this.getAnnouncement();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    }
  }
}
</script>
<style>
.announcement-content img {
  max-width: 100%;
}

.ql-size-large {
  font-size: 1.5em !important;
}

.ql-size-huge {
  font-size: 2.5em !important;
}
.ql-size-small {
  font-size: 0.75em !important;
}
</style>
